import { staleTimes, useQuery } from '@platform/api-client';
import type { TypedClient } from '@platform/openapi';
import { TYPING_DELAY_MS, useDebouncedValue } from '../useDebouncedValue.ts';
import { queryKeys, usePageContext } from '../usePageContext.ts';

export const MIN_SUGGESTION_LENGTH = 3;

export const useReturnSuggestions = (api: TypedClient, typed: string) => {
  const { tenantId } = usePageContext();
  const code = useDebouncedValue(typed.trim(), TYPING_DELAY_MS);
  const enabled = code.length >= MIN_SUGGESTION_LENGTH && typed.trim() !== '';
  const query = useQuery({
    queryKey: queryKeys.orders(tenantId, { returnLookup: code }),
    queryFn: () => api.get('/admin/returns/parcels', { query: { code } }),
    enabled,
    staleTime: staleTimes.orders,
  });
  return {
    active: enabled,
    candidates: enabled ? (query.data?.items ?? []) : [],
    searching: enabled && query.isFetching,
  };
};
